import { useEffect } from "react";

const SITE = "Asana Memorial Foundation";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Per-route document title + description. Note: social-share crawlers read the
// static index.html (site-wide defaults); this updates the browser tab title
// and what JS-rendering search engines (e.g. Google) see per page.
export function useSeo(title, description) {
  useEffect(() => {
    const full = title ? `${title} — ${SITE}` : SITE;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
  }, [title, description]);
}
